module.exports = __webpack_public_path__ + "static/media/ic_searchtype_seaplaneport.1454b85b.svg";